"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlacementDeleteModal = void 0;
var React = _interopRequireWildcard(require("react"));
var _alloyReactModal = require("@adsk/alloy-react-modal");
var _useTranslations = require("../../../utils/i18n/useTranslations");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PlacementDeleteModal = _ref => {
  let {
    isOpen = false,
    onDelete,
    placementText,
    isFile,
    onClose
  } = _ref;
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const modalMessage = isFile ? T.translate("placementDeleteModal.fileMessage", {
    placementText
  }) : T.translate("placementDeleteModal.sheetMessage", {
    placementText
  });
  const modalTitle = isFile ? T.translate("placementDeleteModal.fileTitle") : T.translate("placementDeleteModal.sheetTitle");
  return /*#__PURE__*/React.createElement(_alloyReactModal.ModalConfirmation, {
    style: {},
    show: isOpen,
    onConfirm: onDelete,
    onClose: onClose,
    title: modalTitle,
    message: modalMessage,
    confirmationButtonLabel: T.translate("actions.remove")
  });
};
exports.PlacementDeleteModal = PlacementDeleteModal;
//# sourceMappingURL=PlacementDeleteModal.js.map